"use strict";

/* eslint-disable no-param-reassign */
var _ = require('lodash');
var ga = require('../ga.constants');
var _require = require('../../common/constant/finding-status.constant'),
  IN_PROGRESS = _require.IN_PROGRESS,
  NOT_RESOLVED = _require.NOT_RESOLVED;
module.exports = /*@ngInject*/function ($location, ReportService) {
  var ctrl = this;
  ctrl.status = [{
    label: 'Not Resolved',
    value: NOT_RESOLVED
  }, {
    label: 'In Progress',
    value: IN_PROGRESS
  }];
  ctrl.query = ReportService.openFindingsQuery;
  ctrl.opened = {};
  ctrl.today = new Date();
  ctrl.dateFormats = ['yyyy-MM-dd', 'MM/dd/yyyy'];
  ctrl.open = function (item) {
    ctrl.opened[item] = true;
  };
  ctrl.init = function () {
    ctrl.executeQuery(ctrl.query);
  };
  ctrl.executeQuery = function (query) {
    ctrl.progress = true;
    ReportService.openfindings(query).$promise.then(function (results) {
      ctrl.progress = false;
      ctrl.results = results;
      ctrl.displayStatus = query.status;
      ctrl.configurations = _.uniqBy(ctrl.results.map(function (item) {
        return item.configuration;
      }), function (item) {
        return item._id;
      });
    });
  };
  ctrl.getReport = function (report) {
    $location.url("report/".concat(report._id));
  };
  ctrl.toggleDetail = function (query, result) {
    if (!result.showDetail) {
      ReportService.openfindingsDetail({
        partyId: result.party.id,
        status: query.status,
        beginDate: query.beginDate,
        endDate: query.endDate
      }).$promise.then(function (reports) {
        result.reports = reports;
        result.showDetail = true;
      });
    } else {
      result.showDetail = false;
      result.reports = [];
    }
  };
  ctrl.events = {
    search: [ga.categories.SEARCH, ga.actions.SEARCH, ga.labels.SEARCH_BAR.OPEN_FINDINGS]
  };
  ctrl.init();
};